import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Group extends Vue {
    data: any[] = [];

    @Prop()
    uid!: string;

    @Prop()
    collection!: string;

    mounted() {
        this.getData();
    }

    async getData() {
        const document = await this.$prismic.client.getSingle(this.uid);

        this.data = document.data;

        this.$emit('load');
    }
}
